import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const News: React.FC = () => {
  const news = [
    {
      id: 1,
      title: '公司成功举办2024年度技术创新大会',
      date: '2024-03-15',
      category: '公司新闻',
      summary: '本次大会展示了公司在人工智能、云计算等领域的最新研发成果...',
      image: 'https://images.unsplash.com/photo-1540575467063-178a50c2df87?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
    },
    {
      id: 2,
      title: '新一代智能产品发布会圆满成功',
      date: '2024-03-10',
      category: '产品发布',
      summary: '公司最新研发的智能产品系列获得市场广泛好评...',
      image: 'https://images.unsplash.com/photo-1519389950473-47ba0277781c?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
    },
    {
      id: 3,
      title: '公司与多家知名企业达成战略合作',
      date: '2024-03-05',
      category: '合作动态',
      summary: '此次合作将推动公司在多个领域的业务发展...',
      image: 'https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
    }
  ];

  return (
    <div className="container mx-auto px-4 py-8">
      <motion.h1 
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="text-4xl font-bold text-center mb-12"
      >
        新闻动态
      </motion.h1>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {news.map((item, index) => (
          <motion.article
            key={item.id}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1 }}
            className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow"
          >
            <Link to={`/news/${item.id}`}>
              <div className="relative h-48">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="p-6">
                <span className="text-sm text-blue-600 font-semibold">
                  {item.category}
                </span>
                <h3 className="text-xl font-bold mt-2 mb-2 hover:text-blue-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-gray-600 mb-4">{item.summary}</p>
                <div className="flex items-center text-sm text-gray-500">
                  <span>{item.date}</span>
                </div>
              </div>
            </Link>
          </motion.article>
        ))}
      </div>
    </div>
  );
};

export default News; 